import { render, staticRenderFns } from "./EditOrganisationType.vue?vue&type=template&id=6e9d561d&scoped=true"
import script from "./EditOrganisationType.vue?vue&type=script&lang=js"
export * from "./EditOrganisationType.vue?vue&type=script&lang=js"
import style0 from "./EditOrganisationType.vue?vue&type=style&index=0&id=6e9d561d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9d561d",
  null
  
)

export default component.exports